import videoSpecsTpl from '../templates/video_specs.directive.html';

export default function videoSpecs() {
  return {
    restrict: 'E',
    template: videoSpecsTpl
  };
}
